/*********************************************************************************************
* Read-more x Read-less
	*
*/
document.addEventListener('DOMContentLoaded', function () {
	const wrappers = document.querySelectorAll('.mm-pfc-description');

	wrappers.forEach(wrapper => {
		const description = wrapper.querySelector('.mm-description-hero-collection');
		const toggle = wrapper.querySelector('.mm-read-more');
		const fullText = wrapper.dataset.fullText;

		if (!description || !toggle || !fullText) return;

		const seeMoreText = wrapper.dataset.seeMore || 'Voir plus';
		const seeLessText = wrapper.dataset.seeLess || 'Voir moins';

		toggle.addEventListener('click', () => {
			const isExpanded = description.classList.toggle('expanded');
			description.textContent = isExpanded ? fullText : fullText.split(' ').slice(0, 18).join(' ') + '...';
			toggle.textContent = isExpanded ? seeLessText : seeMoreText;
		});

		// Accessibilité (Enter ou Espace)
		toggle.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				toggle.click();
			}
		});
	});
});
